module.exports = __webpack_public_path__ + "img/3.bd01e8e5.jpg";